<template>
  <div :id="gid">
    <a v-for="(image, key) in imagesData" :key="key" :href="image.largeURL" :data-pswp-width="image.width"
      :data-pswp-height="image.height" target="_blank" rel="noreferrer" :alt="image.alt">
      <img :src="image.thumbnailURL" :alt="image.alt" />
    </a>
  </div>
</template>

<script>
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

export default {
  name: "SimpleGallery",
  props: {
    gid: String,
    images: Array,
  },
  setup(props) {
    return {
      imagesData: props.images,
    };
  },
  mounted() {
    if (!this.lightbox) {
      this.lightbox = new PhotoSwipeLightbox({
        gallery: "#" + this.$props.gid,
        children: "a",
        pswpModule: () => import("photoswipe"),
      });
      this.lightbox.init();
    }
  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  },
  methods: {},
};
</script>
<style>
.galery {
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
}
</style>
